var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.422,
    height: 50.723,
    viewBox: "0 0 56.422 50.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(238.413 -398.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-197.894,423.822c0-6.471.091-12.945-.033-19.413-.075-3.913,2.539-6.075,5.938-5.9,1.477.075,2.959,0,4.44.016,3.459.036,5.547,2.1,5.55,5.532q.016,19.774,0,39.55c0,3.494-2.087,5.552-5.608,5.581-1.583.011-3.166.015-4.749,0-3.466-.034-5.521-2.068-5.532-5.534C-197.906,437.04-197.893,430.431-197.894,423.822Zm4.352-.076q0,9.863,0,19.726c0,1.231.13,1.354,1.37,1.361,1.446.008,2.892.005,4.338,0,1.369-.006,1.485-.117,1.486-1.463q.006-7.127,0-14.251,0-12.395,0-24.787c0-1.352-.113-1.46-1.484-1.464q-2.117-.007-4.234,0c-1.375,0-1.476.1-1.477,1.462Q-193.545,414.038-193.542,423.746Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-202.22,429.635q0,6.816,0,13.629c0,3.91-2.009,5.914-5.913,5.92-1.515,0-3.03.019-4.544,0-3.386-.049-5.485-2.116-5.494-5.5q-.036-14.043,0-28.086a5.065,5.065,0,0,1,5.39-5.461q2.578-.041,5.162,0c3.331.052,5.371,2.1,5.393,5.46C-202.2,420.273-202.22,424.955-202.22,429.635Zm-11.609-.1c0,4.646.013,9.3-.012,13.943-.007.95.3,1.4,1.309,1.369,1.582-.044,3.168-.032,4.751,0,.89.017,1.255-.38,1.215-1.248-.027-.618,0-1.239,0-1.858q0-12.912,0-25.821c0-1.318-.112-1.429-1.4-1.435q-2.219-.011-4.44,0c-1.3.006-1.413.117-1.415,1.419Q-213.835,422.715-213.829,429.533Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-238.406,435.422c0-2.753-.012-5.506,0-8.26a5.107,5.107,0,0,1,5.472-5.483c1.722-.015,3.443-.026,5.163,0a4.971,4.971,0,0,1,5.241,5.164q.085,8.569,0,17.138a4.971,4.971,0,0,1-5.131,5.183c-1.856.068-3.719.068-5.574,0a5.07,5.07,0,0,1-5.167-5.382C-238.426,441-238.406,438.21-238.406,435.422Zm11.547,0c0-2.752-.01-5.505.007-8.259.005-.758-.246-1.154-1.07-1.141-1.686.029-3.372.025-5.059,0-.812-.012-1.082.376-1.079,1.142q.02,8.258,0,16.518c0,.853.375,1.168,1.187,1.157,1.584-.021,3.167-.034,4.749.006.924.024,1.3-.326,1.283-1.269C-226.882,440.857-226.858,438.138-226.859,435.419Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.412bbef4664154a2b9ed9bb4819b1081.svg";
export { ForwardRef as ReactComponent };